import { EntityModel } from '@/interfaces'
import {
  ALL_TENANT_CONTENTS_QUERY,
  CREATE_TENANT_CONTENT_MUTATION,
  DELETE_TENANT_CONTENT_MUTATION,
  FORCE_DELETE_TENANT_CONTENT_MUTATION,
  SINGLE_TENANT_CONTENT_QUERY,
  UPDATE_TENANT_CONTENT_MUTATION,
} from './graphql'

const tenantContentModel: EntityModel = {
  name: 'tenantContent',
  namePlural: 'tenantContents',
  uniqueName: 'tenantContent',
  uniqueNamePlural: 'tenantContents',
  path: 'config/tenant/tenant_content',
  baseUrl: '/config/tenant/tenant_contents',
  translationPrefix: 'entities:tenantContent.',
  getDisplayName: (values: any) => {
    return 'TENANT CONTENT'
  },
  gql: {
    getAll: ALL_TENANT_CONTENTS_QUERY,
    getSingle: SINGLE_TENANT_CONTENT_QUERY,
    create: CREATE_TENANT_CONTENT_MUTATION,
    update: UPDATE_TENANT_CONTENT_MUTATION,
    delete: DELETE_TENANT_CONTENT_MUTATION,
    forceDelete: FORCE_DELETE_TENANT_CONTENT_MUTATION,
  },
  attributes: {
    bookingInsuranceInfo: {
      name: 'bookingInsuranceInfo',
      label: 'entities:tenantContent.attributes.bookingInsuranceInfo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    co2CompensationInfo: {
      name: 'co2CompensationInfo',
      label: 'entities:tenantContent.attributes.co2CompensationInfo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [],
    },
  },
}

export default tenantContentModel
